import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'
import localStorage from 'utils/localStorage'

/**
 * Type Interface for the body of the VerifyOTP request
 */
export interface OtpBody {
	otp: string
}

/**
 * Type Definition for the Response you get from OTP verifucation
 */
export interface OtpVerification {
	token: string
}

const VerifyOTP = async (body: OtpBody) => {
	try {
		const { data } = await axios.post<OtpVerification>(
			'management/verify-otp',
			body
		)
		localStorage.set('token', data.token)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default VerifyOTP
